// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_empty_11n0s_5huaf_13:not(#\\9){color:var(--color-text-empty-jskpnv, #687078)}\n", ""]);
// Exports
module.exports = exports;
